import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'next-i18next';
import _ from 'lodash';
import s from './Spar.module.scss';

const Spar = ({ spar, gdprText }) => {
    const {t} = useTranslation();

    const success = _.get(spar, 'success', false);
    if (!success) {
        return (
            <div className={s['Spar']}>
                <p className={s['Spar__Error']}>{t('spar.error')}</p>
            </div>
        );
    }

    const firstName = _.get(spar, 'obfuscate.additionalPersonDetails.chosenName', '');
    const lastName = _.get(spar, 'obfuscate.personDetails.Efternamn', '');
    const streetAdress = _.get(spar, 'obfuscate.currentAddress.Utdelningsadress2', '');
    const zipCode = _.get(spar, 'obfuscate.currentAddress.PostNr', '');
    const city = _.get(spar, 'obfuscate.currentAddress.Postort', '');

    return (
        <div className={s['Spar']}>
            <div className={s['Spar__Content']}>
                <ul>
                    <li className={s['Spar__Info']}>
                        <h3 className={s['Spar__Title']}>{t('spar.name')}</h3>
                        {`${firstName} ${lastName}`}
                    </li>
                    <li className={s['Spar__Info']}>
                        <h3 className={s['Spar__Title']}>{t('spar.streetAddress')}</h3>
                        {streetAdress}
                    </li>
                    <li className={s['Spar__Info']}>
                        <h3 className={s['Spar__Title']}>{t('spar.postAddress')}</h3>
                        {`${zipCode} ${city}`}
                    </li>
                </ul>
            </div>
            {gdprText &&
                <div
                    className={s['Spar__GdprText']}
                    dangerouslySetInnerHTML={{ __html: gdprText }}
                />
            }
        </div>
    );
};

Spar.propTypes = {
    spar: PropTypes.object,
    gdprText: PropTypes.string,
};

Spar.defaultProps = {
    spar: {},
    gdprText: '',
};

export default Spar;
